const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/portals/$portalId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
type PortalSearchParams = {
  configure?: boolean;
};
export const Route = createFileRoute('/(app)/org/$org/idea-management/portals/$portalId/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (search: Record<string, unknown>): PortalSearchParams => {
    return {
      configure: search.configure as boolean | undefined
    };
  },
  staticData: {
    topNav: {
      title: 'ideaManagement.general.portals'
    },
    collapseLeftNav: true
  }
});